/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({
  organizationId: ZodTypes.Id,
  projectId: ZodTypes.Id,
  clusterId: ZodTypes.Id,
});

export const GetClusterPgConfig = {
  id: 'cluster-pgconfig.get',
  tag: 'Cluster',
  summary: 'Get cluster pg config',
  description: 'Retrieve the pg config information of a cluster',
  method: 'get',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) =>
    `/organization/${params.organizationId}/project/${params.projectId}/cluster/${params.clusterId}/parameter`,
  request: {
    params: Params,
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.strictObject({
            formData: z.any(),
            rawSchema: z.any(),
            schema: z.any(),
            uiSchema: z.any(),
          }),
        },
      },
    },
  },
} as const satisfies Endpoint;
